import {
  Directive,
  OnInit,
  ElementRef,
  Input,
  EventEmitter,
  Output,
  ViewContainerRef,
  AfterViewInit,
} from '@angular/core';

export interface GridDynamicPageSizeOptions {
  enabled?: boolean;
  wrapperRef?: ViewContainerRef;
  defaultPageSize?: number;
  calculateAfterInit?: boolean;
  calculateAfterViewInit?: boolean;
  hasHorizontalScroll?: boolean;
  useAlternativeMethod?: boolean;
  currentZoomLevel?: number;
}

@Directive({
  standalone: false,
  selector: '[tiGridDynamicPageSize]',
})
export class GridDynamicPageSizeDirective implements OnInit, AfterViewInit {
  @Input('tiGridDynamicPageSize') options: GridDynamicPageSizeOptions;
  @Output() rowsCalculate = new EventEmitter<number>();

  constructor(private readonly grid: ElementRef) {}

  ngOnInit() {
    if (this.options.calculateAfterInit) {
      setTimeout(() => this.getPageSize(this.options.defaultPageSize), 0);
    }
  }

  ngAfterViewInit() {
    if (this.options.calculateAfterViewInit) {
      setTimeout(() => this.getPageSize(this.options.defaultPageSize), 0);
    }
  }

  getPageSize(currentPageSize: number, options?: GridDynamicPageSizeOptions): number {
    this.options = options || this.options;
    if (options && options.useAlternativeMethod && options.currentZoomLevel) {
      return this.getAlternativePageSize(currentPageSize || 0);
    } else {
      const pageSize = this.options ? this.calcPageSize(currentPageSize || 0) : currentPageSize || 0;
      return pageSize >= 0 ? pageSize : 0;
    }
  }

  getAlternativePageSize(currentPageSize?) {
    if (!this.options.enabled) {
      return currentPageSize;
    }
    if (this.options.wrapperRef) {
      const gridWrapper = this.options.wrapperRef.element.nativeElement.parentElement;
      if (!gridWrapper /* || currentPageSize > 0*/) {
        return currentPageSize;
      }
    }

    if (!this.grid.nativeElement.offsetHeight) {
      this.rowsCalculate.emit(0);
      return 0;
    }

    const heightScroll = 10;
    const gridList = document.getElementsByTagName('kendo-grid-list')[0] as HTMLElement;
    /*    const hasHorizontalScroll = BrowserDetectionService.isIE() // there's always a horizontal scroll in the documents grid in IE11, and it's hard to get rid of it.
      ? true
      : gridList.scrollWidth > gridList.clientWidth;*/

    let rows: number;
    // note: investigate window.devicePixelRatio for further possible improvements or bug fixes for this row counter
    // const baseFont = 12; // px, relative, for base zoom of 0.8, not used
    const baseZoomLevel = 0.8; // should use some constant...
    const zoomRatio = 1 + this.options.currentZoomLevel - baseZoomLevel;
    const gridRowHeight = 33 * zoomRatio;
    const gridListInitialHeight = gridList.clientHeight;
    const initialKendoGridToolbarHeight = 28 * zoomRatio;
    const secondaryKendoGridToolbarHeight = 46 * zoomRatio;
    const kendoGridHeaderHeight = 32 * zoomRatio;
    const initialToSecondaryToolbarHeightOffset = secondaryKendoGridToolbarHeight - initialKendoGridToolbarHeight;
    // in some cases such as coding panel resizing horizontal scrollbar can appear after calculating... so let's assume it's always there
    const gridRowsFullHeight =
      gridListInitialHeight - initialToSecondaryToolbarHeightOffset - kendoGridHeaderHeight - heightScroll; // ((hasHorizontalScroll || alwaysIncludeHorizontalScrollbar) && heightScroll)
    rows = Math.floor(gridRowsFullHeight / gridRowHeight);
    rows = rows > 1 ? rows : 1;
    //debugger
    this.rowsCalculate.emit(rows);
    return rows;
  }

  private calcPageSize(currentPageSize: number): number {
    if (!this.options.enabled) {
      return currentPageSize;
    }

    if (this.options.wrapperRef) {
      const gridWrapper = this.options.wrapperRef.element.nativeElement.parentElement;
      if (!gridWrapper /* || currentPageSize > 0*/) {
        return currentPageSize;
      }
    }
    return this.getGridRowsCount(currentPageSize) || 0;
  }

  // TODO: it returns less rows than it should be, need to investigate
  private getGridRowsCount(currentPageSize: number): number {
    if (!this.grid.nativeElement.offsetHeight) {
      this.rowsCalculate.emit(0);
      return 0;
    }

    const heightGridRow = 51;
    const containerHeight = this.grid.nativeElement.querySelectorAll('.k-grid-content')?.[0]?.offsetHeight;
    let rows: number;
    rows = Math.floor(containerHeight / heightGridRow) - 1;
    rows = rows > 1 ? rows : 1;
    this.rowsCalculate.emit(rows);

    return rows > currentPageSize ? rows : currentPageSize;
  }
}
